import { BorrowerModel } from './../../models/borrower.model';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LogSummaryModel } from '../../models/log-summary.model';
import { SearchService } from '../../services/search.service';
import { ChartDataSets, ChartOptions, ChartType } from 'chart.js';
import { Label } from 'ng2-charts';
import { MatAccordion } from '@angular/material/expansion';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.css']
})
export class MainComponent implements OnInit {
  @ViewChild(MatAccordion) accordion: MatAccordion;
  userIdentifier: string;
  userSummaryLogs: LogSummaryModel[];
  borrowerRegDate = '18/05/1015';
  selectedLog: LogSummaryModel;
  displayedColumns: string[] = ['sid', 'date', 'duration', 'count', 'actions'];
  borrowerModel: BorrowerModel;


  public barChartOptions: ChartOptions = {
    responsive: true,
    scales: { xAxes: [{}], yAxes: [{}] },
    plugins: {
      datalabels: {
        anchor: 'end',
        align: 'end',
      }
    }
  };
  public barChartLabels: Label[] = ['Phone', 'PC', 'Tablet'];
  public barChartType: ChartType = 'horizontalBar';
  public barChartLegend = true;
  public barChartData: ChartDataSets[] = [
    { data: [65, 59, 80], label: 'Visits' }
  ];

  mostViewedPages: Label[] = ['My Dashboard', 'My Funding', 'Repayment Assistance', 'Others'];
  public mostViewedPagesData: ChartDataSets[] = [
    { data: [29, 25, 14, 40], label: 'Visits' }
  ];
  public months: Label[] = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  public visitsPerMonth: ChartDataSets[] = [
    { data: [1, 5, 8, 6, 10, 3, 2, 1, 8, 0, 9, 1], label: 'Visits' }
  ];
  constructor(private route: ActivatedRoute,
              private searchService: SearchService,
              private router: Router) {
    this.selectedLog = null;
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      this.userIdentifier = params.get('sinOrBorrowerId');
      this.searchService.getUserSummaryTraceData(this.userIdentifier).subscribe(userData => {
        this.borrowerModel = userData;
        this.userSummaryLogs = this.borrowerModel.records.sort((a, b) => b.startDate - a.startDate);
      }, err => {
        this.userSummaryLogs = [];
        this.router.navigate(['/error']);
      });
    });
  }

  public viewLogs(log: LogSummaryModel): void {
    this.selectedLog = log;
    const url = `/user-activity/${log.sid}`;
    this.router.navigate([url]);
  }

  public getStartDate(log: LogSummaryModel): string {
    const dt = new Date(log.startDate);
    return `${(dt.getMonth() + 1).toString().padStart(2, '0')}/${dt.getDate().toString().padStart(2, '0')}/${dt.getFullYear().toString().padStart(4, '0')} ${dt.getHours().toString().padStart(2, '0')}:${dt.getMinutes().toString().padStart(2, '0')}`;
  }

  public getDuration(log: LogSummaryModel): string {
    const minDuration = Math.floor(log.duration / 60);
    return `${minDuration}m`;
  }

  public goBack(): void {
    this.router.navigate(['/search']);
  }
}
